import { styled } from '@mui/material'

export const ExpandCollapseContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})
